<main>
  <section>
    <router-outlet></router-outlet>
  </section>
</main>
